// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"521":"a2fd550f","803":"8a63693d"}[chunkId] + ".chunk.css";
};